export function isNotNull(value) {
    return value !== null;
}
export function hasValue(value) {
    return value !== null && value !== undefined;
}
